import '../styles/pages/FAQ.scss';
import QuestionAnswer from '../components/QuestionAnswer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
    const { t } = useTranslation();
    const [displayAnswer, setDisplayAnswer] = useState(null);
    const questionsAnswers = [
        {
            title: t('faq.sections.creation.title'), 
            subtitle: t('faq.sections.creation.subtitle'), 
            QA: [
                {
                    question: t('faq.sections.creation.q1.question'), 
                    answers: [t('faq.sections.creation.q1.answer1'), t('faq.sections.creation.q1.answer2')]
                },
                {
                    question: t('faq.sections.creation.q2.question'), 
                    answers: [t('faq.sections.creation.q2.answer1'), t('faq.sections.creation.q2.answer2')]
                },
            ]
        },
        {
            title: t('faq.sections.fiscal.title'), 
            subtitle: t('faq.sections.fiscal.subtitle'), 
            QA: [
                {
                    question: t('faq.sections.fiscal.q1.question'), 
                    answers: [t('faq.sections.fiscal.q1.answer1'), t('faq.sections.fiscal.q1.answer2')]
                },
                {
                    question: t('faq.sections.fiscal.q2.question'), 
                    answers: [t('faq.sections.fiscal.q2.answer1'), t('faq.sections.fiscal.q2.answer2')]
                },
            ]
        },
        {
            title: t('faq.sections.accounting.title'), 
            subtitle: t('faq.sections.accounting.subtitle'), 
            QA: [
                {
                    question: t('faq.sections.accounting.q1.question'), 
                    answers: [t('faq.sections.accounting.q1.answer1'), t('faq.sections.accounting.q1.answer2')]
                },
            ]
        },
        {
            title: t('faq.sections.investment.title'), 
            subtitle: t('faq.sections.investment.subtitle'), 
            QA: [
                {
                    question: t('faq.sections.investment.q1.question'), 
                    answers: [t('faq.sections.investment.q1.answer1'), t('faq.sections.investment.q1.answer2')]
                },
                {
                    question: t('faq.sections.investment.q2.question'), 
                    answers: [t('faq.sections.investment.q2.answer1'), t('faq.sections.investment.q2.answer2')]
                },
            ]
        },
    ]
    return(
        <div className="main-container">
            <div className='faq-header'>
                <h1> {t('faq.header.title')} <span className='colored'>{t('faq.header.colored')}</span> {t('faq.header.end')} </h1>
            </div>
            <div className='faq-sections'>
                <div className='faq-section'>
                    {questionsAnswers.map((section, idx) => (
                        <div key={idx} className='faq-section-block'>
                            <div className='faq-section-title'>
                                <h2> {section.title} </h2>
                                <span> {section.subtitle} </span>
                            </div>
                            <div className='faq-questions-answers'>
                                {section.QA.map((qa, qIdx) => (
                                    <QuestionAnswer
                                        key={qIdx}
                                        index={qIdx + 1}
                                        question={qa.question}
                                        answers={qa.answers}
                                        displayAnswer={displayAnswer === qIdx + 1 + idx * 10}
                                        setDisplayAnswer={(val) => setDisplayAnswer(val ? qIdx + 1 + idx * 10 : null)}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='faq-footer'>
                <h2> {t('faq.footer.title')} </h2>
                <a href="https://wa.me/21620372623" target="_blank" rel="noopener noreferrer">
                   <button> {t('faq.footer.button')} </button>
                </a>
            </div>
        </div>
    )
    
}

export default FAQ;
